<template>
  <div class="medical-payment-breakdown">
    <base-loading :waitFlg="waitFlg" />
    <div class="search">
      <search-area
        :periodFlg="true"
        :periodLabel="'診療日期間'"
        :periodClearFlg="false"
        :defaultStartDate="new Date()"
        :defaultEndDate="new Date()"
        :maxStartDate="new Date()"
        :maxEndDate="new Date()"
        :searchButtonFlg="true"
        :searchButtonLabel="'ダウンロード'"
        :waitFlg="waitFlg"
        :withinOneYearRuleFlg="true"
        :searchButtonWidthForSmallScreens="'100px'"
        @input-start-date="inputDate($event, 'start')"
        @input-end-date="inputDate($event, 'end')"
        @search="aggregateMedicalPayments"
      />
    </div>
    <div class="precautions">
      <div class="title">注意事項</div>
      <div class="text">・「会計済」のデータのみが集計対象です。</div>
      <div class="text second-line">
        「未会計」、「未収金」、「再会計」のデータは集計対象外です。
      </div>
      <div class="text">・消費税は含んでおりません。</div>
      <div class="text">・全体割引、全体値引は適用されません。</div>
      <div class="text">
        上記理由から、同一期間の入金状況とは差額が生じることがあります。
      </div>
      <div class="text classification">
        ・診療項目の「分類」は、「中分類」欄に記載しています。
      </div>
      <div class="text second-line">
        （例）大分類が検査、分類が身体検査、診療項目名が体温の場合
      </div>
      <div class="text second-line">
        ダウンロードしたcsvファイルでは「大分類」が検査、「中分類」が身体検査、「小分類」が空欄、「診療項目内容」が体温のように記載されます。
      </div>
    </div>
    <announce-popup
      v-if="popupFlg"
      :type="type"
      :title="title"
      :buttons="buttons"
      @close="popupFlg = false"
      >{{ popupMessage }}</announce-popup
    >
  </div>
</template>

<script>
import SearchArea from '@/components/parts/molecules/SearchArea'
import BaseLoading from '@/components/parts/atoms/BaseLoading'
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import { getAxiosObjectForAnalytics } from '@/utils/library'
import { downloadCsv } from '@/utils/csv'
import { stringify } from 'csv-stringify/lib/sync'
import moment from 'moment'

export default {
  name: 'MedicalPaymentBreakdown',
  components: { SearchArea, BaseLoading, AnnouncePopup },
  data() {
    return {
      startDate: '',
      endDate: '',
      popupFlg: false,
      type: '',
      title: '',
      popupMessage: '',
      buttons: [],
      waitFlg: false
    }
  },
  computed: {},
  methods: {
    inputDate(date, dateType) {
      dateType === 'start' ? (this.startDate = date) : (this.endDate = date)
    },
    async aggregateMedicalPayments() {
      try {
        this.waitFlg = true
        const axiosObject = getAxiosObjectForAnalytics()
        const res = await axiosObject.get(
          '/analytics/medical-payment-breakdown',
          { params: { startDate: this.startDate, endDate: this.endDate } }
        )
        this.download(res.data.aggregatedDatum, res.data.aggregatedDateTime)
        this.waitFlg = false
      } catch (err) {
        this.waitFlg = false
        this.type = 'failure'
        this.title = '失敗'
        this.buttons = ['閉じる']
        this.popupMessage =
          '集計に失敗しました。\n暫く待ってから再度お試し下さい。'
        this.popupFlg = true
      }
    },
    makeCsvStr(csv) {
      return stringify(csv, {
        cast: {
          boolean: function(value) {
            return value.toString()
          }
        }
      })
    },
    createCsv(data, aggregatedDateTime) {
      const headerStr =
        '飼主ID,飼主名,患者ID,患者名,種別,診療日,担当者,診断名１,診断名２,大分類,中分類,小分類,診療項目内容,単価（￥）,数量,割引（%）,値引（￥）,小計（￥）,決済方法,入院\n'
      const bodyStr = this.makeCsvStr(data)
      const emptyArea = ',,,,,,,,,,,,,,,,,,,'
      const infoHeaderStr = emptyArea + ',集計日時,診療日期間\n'
      const infoBodyStr =
        emptyArea +
        ',' +
        moment(aggregatedDateTime, 'YYYYMMDDHHmmss').format(
          'YYYY/MM/DD HH:mm:ss'
        ) +
        ',' +
        `${moment(this.startDate, 'YYYYMMDD').format('YYYY/MM/DD')}~${moment(
          this.endDate,
          'YYYYMMDD'
        ).format('YYYY/MM/DD')}`
      const csvStr = headerStr + bodyStr + infoHeaderStr + infoBodyStr
      const fileName = 'medical_treatment_items'
      return { csvStr, fileName }
    },
    download(data, aggregatedDateTime) {
      const { csvStr, fileName } = this.createCsv(data, aggregatedDateTime)
      downloadCsv(csvStr, fileName)
    }
  }
}
</script>

<style lang="scss" scoped>
.medical-payment-breakdown {
  > .search {
    margin-top: 40px;
  }
  > .precautions {
    margin-top: 30px;
    color: #{$tomato};
    font-size: 16px;
    > .text {
      margin-top: 2px;
    }
    > .second-line {
      margin-left: 9px;
    }
    > .classification {
      margin-top: 20px;
    }
  }
}
</style>
